import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../stores/auth.store';
import './SignInForm.scss';
import { useTranslation } from '../../i18n/i18n';
import { dashboardPath, locationInstallationPath, restorePasswordPath } from '../../routes';
import { TemporaryPasswordError } from '../../api/auth.api';

interface FormValues {
  username: string;
  password: string;
}

const SignInForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<FormValues>();
  const login = useAuthStore((state) => state.login);
  const [messageApi, contextHolder] = message.useMessage();
  const { t } = useTranslation('auth', { keyPrefix: 'signin' });

  const onFinish = async (values: FormValues) => {
    try {
      await login(values.username, values.password);
      messageApi.success(t('success'));
      navigate(`/${dashboardPath}/${locationInstallationPath}`);
    } catch (error) {
      if (error instanceof TemporaryPasswordError) {
        navigate(restorePasswordPath, {
          state: { email: error.email, temporaryPassword: values.password },
        });
        return;
      }
      console.error('[SignIn] login failed:', error);
      messageApi.error(t('error'));
    }
  };

  return (
    <div>
      {contextHolder}
      <Form<FormValues> form={form} name="login" onFinish={onFinish} className={'SignInForm'}>
        {/* Username */}
        <Form.Item name="username" rules={[{ required: true, message: t('username_required') }]}>
          <Input
            prefix={<UserOutlined className="SignInForm__siteFormItemIcon" />}
            placeholder={t('username_placeholder')}
          />
        </Form.Item>

        {/* Password */}
        <Form.Item name="password" rules={[{ required: true, message: t('password_required') }]}>
          <Input.Password
            prefix={<LockOutlined className="SignInForm__siteFormItemIcon" />}
            type="password"
            placeholder={t('password_placeholder')}
          />
        </Form.Item>

        {/* Submit */}
        <Form.Item>
          <Button type="primary" htmlType="submit" className="SignInForm__loginFormButton" block>
            {t('submit')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SignInForm;
